module.exports = __webpack_public_path__ + "img/program-icon-4.9ddf7f8a.png";